import { render, staticRenderFns } from "./blockAB6.vue?vue&type=template&id=722c4fa8&"
import script from "./blockAB6.vue?vue&type=script&lang=js&"
export * from "./blockAB6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports